import React, { FC } from 'react';
import Icon from '../icon';
import RoutableNotEditableLink from '../routableNotEditableLink';
import { TCTAWithArrow } from './types/ctaWithArrow.types';

const CTAWithArrow: FC<TCTAWithArrow> = ({ href, target = '', text, onClick }) => (
  <div className="cta-with-arrow">
    <RoutableNotEditableLink href={href} target={target} onClick={onClick}>
      {text}
      <span className="cta-with-arrow__text">
        <Icon iconName="arrow-simple-right" size={24} color="primary" extraClassName="cta-with-arrow__icon" />
      </span>
    </RoutableNotEditableLink>
  </div>
);

export default CTAWithArrow;
